import { render } from "./loaddialogerror.vue?vue&type=template&id=04b9d2fc"
import script from "./loaddialogerror.vue?vue&type=script&lang=js"
export * from "./loaddialogerror.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__